import { Box, styled, Typography, Button } from "@mui/material";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import FavoriteIcon from "@mui/icons-material/Favorite";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PublicIcon from "@mui/icons-material/Public";
import PublicOffIcon from "@mui/icons-material/PublicOff";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CreditCardOffIcon from "@mui/icons-material/CreditCardOff";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocationOffIcon from "@mui/icons-material/LocationOff";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useViewport } from "../../helpers";

const LINE_CLAMP_MOBILE = 6;
const LINE_CLAMP_DESKTOP = 2;
const LETTERS_BY_LINE_MOBILE = 48;
const LETTERS_BY_LINE_DESKTOP = 100;

const PREFIX = "PurchaseGeolocInfos";

const classes = {
  statisticsContainer: `${PREFIX}-statisticsContainer`,
  statisticsIcon: `${PREFIX}-statisticsIcon`,
  statistics: `${PREFIX}-statistics`,
  descriptionContainer: `${PREFIX}-descriptionContainer`,
  description: `${PREFIX}-description`,
  descriptionButtonContainer: `${PREFIX}-descriptionButtonContainer`,
  descriptionButton: `${PREFIX}-descriptionButton`,
  collapsed: `${PREFIX}-collapsed`,
  expanded: `${PREFIX}-expanded`,
};

const PurchaseGeolocInfosContainer = styled("div")(({ theme }) => ({
  [`& .${classes.statisticsContainer}`]: {
    display: "flex",
    justifyContent: "space-around",
    padding: "20px 20px 0 20px",
  },

  [`& .${classes.statisticsIcon}`]: {
    margin: "10px",
  },

  [`& .${classes.statistics}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "30%",
    marginBottom: "20px",
  },

  [`& .${classes.descriptionContainer}`]: {
    width: "90%",
    margin: "0 auto 10px auto",
    position: "relative",
  },

  [`& .${classes.description}`]: {
    textAlign: "justify",
    transition: "max-height 0.3s ease",
  },

  [`& .${classes.collapsed}`]: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: LINE_CLAMP_DESKTOP, // Limite à 2 lignes
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("md")]: {
      WebkitLineClamp: LINE_CLAMP_MOBILE, // Limite à 6 lignes
    },
  },

  [`& .${classes.expanded}`]: {
    overflow: "visible",
    WebkitLineClamp: "unset",
  },

  [`& .${classes.descriptionButtonContainer}`]: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
}));

const PurchaseGeolocInfos = ({ exparienceData }) => {
  const { t } = useTranslation();
  const { width } = useViewport();

  const [expanded, setExpanded] = useState(false);

  return (
    <PurchaseGeolocInfosContainer>
      <Box className={classes.statisticsContainer}>
        <Box className={classes.statistics}>
          <RocketLaunchIcon
            color="primary"
            className={classes.statisticsIcon}
          />
          <Typography variant="body2">
            {exparienceData?.statistics.launch}
          </Typography>
        </Box>
        <Box className={classes.statistics}>
          <FavoriteIcon color="primary" className={classes.statisticsIcon} />
          <Typography variant="body2">
            {exparienceData?.statistics.like}
          </Typography>
        </Box>
        <Box className={classes.statistics}>
          <VisibilityIcon color="primary" className={classes.statisticsIcon} />
          <Typography variant="body2">
            {exparienceData?.statistics.view +
              exparienceData?.statistics.webview}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.descriptionContainer}>
        <Typography
          variant="body1"
          className={`${classes.description} ${
            expanded ? classes.expanded : classes.collapsed
          }`}
          dangerouslySetInnerHTML={{
            __html: exparienceData?.description.initial,
          }}
        />
        {exparienceData?.description.initial.length >
          (width < 769
            ? LETTERS_BY_LINE_MOBILE * LINE_CLAMP_MOBILE
            : LETTERS_BY_LINE_DESKTOP * LINE_CLAMP_DESKTOP) && (
          <Box className={classes.descriptionButtonContainer}>
            <Button
              onClick={() => setExpanded((prev) => !prev)}
              color="primary"
            >
              {expanded ? t("purchaseGeoloc.less") : t("purchaseGeoloc.more")}
            </Button>
          </Box>
        )}
      </Box>
      <Box className={classes.statisticsContainer}>
        {exparienceData?.published ? (
          <Box className={classes.statistics}>
            <PublicIcon color="primary" className={classes.statisticsIcon} />
            <Typography variant="body2">
              {t("purchaseGeoloc.published")}
            </Typography>
          </Box>
        ) : (
          <Box className={classes.statistics}>
            <PublicOffIcon color="primary" className={classes.statisticsIcon} />
            <Typography variant="body2">
              {t("purchaseGeoloc.unpublished")}
            </Typography>
          </Box>
        )}
        {exparienceData?.packageId === "faz_099_24h" ? (
          <Box className={classes.statistics}>
            <CreditCardIcon
              color="primary"
              className={classes.statisticsIcon}
            />
            <Typography variant="body2">
              {t("purchaseGeoloc.premium")}
            </Typography>
          </Box>
        ) : (
          <Box className={classes.statistics}>
            <CreditCardOffIcon
              color="primary"
              className={classes.statisticsIcon}
            />
            <Typography variant="body2">{t("purchaseGeoloc.free")}</Typography>
          </Box>
        )}
        {exparienceData?.securedByPosition ? (
          <Box className={classes.statistics}>
            <LocationOnIcon
              color="primary"
              className={classes.statisticsIcon}
            />
            <Typography variant="body2">
              {t("purchaseGeoloc.geolocated")}
            </Typography>
          </Box>
        ) : (
          <Box className={classes.statistics}>
            <LocationOffIcon
              color="primary"
              className={classes.statisticsIcon}
            />
            <Typography variant="body2" sx={{ textAlign: "center" }}>
              {t("purchaseGeoloc.nonGeolocated")}
            </Typography>
          </Box>
        )}
      </Box>
    </PurchaseGeolocInfosContainer>
  );
};

export default PurchaseGeolocInfos;
